'use client'

import React from 'react'
import { Anchor, Box, Group, Stack, Text, ThemeIcon } from '@mantine/core'
import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './Task.module.css'

interface TaskProps {
  title: string
  description: string
  isCompleted: boolean
  actionText: string
  actionUrl: string
  displayActionButton: boolean
}

const Task: React.FC<TaskProps> = ({
  title,
  description,
  isCompleted,
  actionText,
  actionUrl,
  displayActionButton = true,
}) => {
  return (
    <Box className={styles.taskContainer}>
      <Group align="flex-start" gap="md" className={styles.taskContent}>
        <ThemeIcon
          className={styles.statusIcon}
          variant={isCompleted ? 'filled' : 'outline'}
          color={isCompleted ? 'green' : 'gray'}
          size="lg"
          radius="xl"
        >
          <FontAwesomeIcon icon={faCheck} />
        </ThemeIcon>

        <Stack gap="md" className={styles.taskText}>
          <Text size="md" fw={600}>
            {title}
          </Text>
          <Text size="sm">{description}</Text>
          {displayActionButton && (
            <Anchor className={styles.actionButton} href={actionUrl} underline="never">
              {actionText}
            </Anchor>
          )}
        </Stack>
      </Group>
    </Box>
  )
}

export default Task
